import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD_PRIMITIVE__float } from '../number/FIELD_PRIMITIVE__float';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

export class FIELD__list_float extends FIELD__list_base_generic<FIELD_PRIMITIVE__float> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_LIST__FLOAT;

  /*
   *
   */

  sort_items(items: FIELD_PRIMITIVE__float[]) {
    items.sort(FIELD_PRIMITIVE__float.sort_by_value);
  }

  /*
   *
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.FLOAT;
  }

  protected override _create_item_internal__default() {
    return FIELD_PRIMITIVE__float.create_field_container_default();
  }
}
